export const ArrowBack = (props) => (
  <svg
    width='17'
    height='16'
    viewBox='0 0 17 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...props?.style }}
  >
    <g clipPath='url(#clip0_557_7552)'>
      <path
        d='M3.16732 7.33366H11.2807L7.55398 3.60699L8.50065 2.66699L13.834 8.00033L8.50065 13.3337L7.56065 12.3937L11.2807 8.66699H3.16732V7.33366Z'
        fill={props?.color || '#94A3B8'}
      />
    </g>
    <defs>
      <clipPath id='clip0_557_7552'>
        <rect width='16' height='16' fill='white' transform='matrix(-1 0 0 1 16.5 0)' />
      </clipPath>
    </defs>
  </svg>
);
